import { ChangeEvent, FC, useEffect, useRef, useState } from "react";
import styles from "./styles.module.scss";
import {
  Button,
  PaginationButtons,
  SearchInput,
  Tag,
  UserFilter,
  UserItemCoachView,
} from "../../../components";
import { useSearchParams } from "react-router-dom";
import clsx from "clsx";
import { ArrowSmallDownIcon, DownloadIcon, FilterIcon } from "../../../assets";
import { PulseLoader } from "react-spinners";
import { getUsers, getUsersCSV } from "../../../services/users.service";
import { useDebounce, useOutsideClick } from "../../../hooks";
import { IUser } from "../../../models";
import fileDownload from "js-file-download";
import {
  SubscriptionPlans,
  SubscriptionStatuses,
} from "../../../components/UserFilter";
import { useFiltersStore } from "../../../store/usersFilterStore";
import { UserProfileCoachView } from "../../../widgets";

const usersLimit = 20;

const UsersCoach: FC = (): JSX.Element => {
  const filterRef = useRef<HTMLDivElement>(null);

  const {
    filterGender,
    setFilterGender,
    filterSubscriptionStatus,
    setFilterSubscriptionStatus,
    filterSubscriptionType,
    setFilterSubscriptionType,
    isProd,
    setIsProd,
    completedDaysPercentageMin,
    setCompletedDaysPercentageMin,
    completedDaysPercentageMax,
    setCompletedDaysPercentageMax,
    search,
    setSearch,
    nameSort,
    setNameSort,
    genderSort,
    setGenderSort,
    emailSort,
    setEmailSort,
    cancellationDateSort,
    setCancellationDateSort,
    dateSort,
    setDateSort,
    compDaysSort,
    setCompDaysSort,
    completedDaysPercentageSort,
    setCompletedDaysPercentageSort,
    subscriptionStatusSort,
    setSubscriptionStatusSort,
    subscriptionTypeSort,
    setSubscriptionTypeSort,
  } = useFiltersStore();

  const debounceSearch = useDebounce(search, 600);
  const debouncedCompletedDaysPercentageMin = useDebounce(
    completedDaysPercentageMin,
    600
  );
  const debouncedCompletedDaysPercentageMax = useDebounce(
    completedDaysPercentageMax,
    600
  );

  const [isOpenFilter, setIsOpenFilter] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [pagesCount, setPagesCount] = useState(0);
  const [users, setUsers] = useState<IUser[]>([]);

  const [count, setCount] = useState(0);

  const [regularUsersCount, setRegularUsersCount] = useState(0);

  const [isLoadingCSV, setIsLoadingCSV] = useState(false);

  const [searchParams, setSearchParams] = useSearchParams();

  useOutsideClick(filterRef, () => setIsOpenFilter(false));

  const userIdFromUrl = searchParams.get("userId");

  const handleCloseModal = () => {
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.delete("userId");
    setSearchParams(newSearchParams);
  };

  const onChangePage = (page: number) => {
    searchParams.set("page", page?.toString());
    setSearchParams(searchParams, { replace: true });
  };

  const onChangeSearch = (e: ChangeEvent<HTMLInputElement>) => {
    onChangePage(1);
    setSearch(e.target.value);
  };
  const page = searchParams.get("page");

  const getCountOfRegularUsers = async () => {
    try {
      const { data } = await getUsers(
        "",
        0,
        20,
        [],
        nameSort !== 0
          ? "fullName"
          : genderSort !== 0
          ? "gender"
          : emailSort !== 0
          ? "email"
          : dateSort !== 0
          ? "onboardingAt"
          : subscriptionStatusSort !== 0
          ? "subscriptionStatus"
          : subscriptionTypeSort !== 0
          ? "subscriptionType"
          : compDaysSort !== 0
          ? "numberOfCompletedDays"
          : completedDaysPercentageSort !== 0
          ? "completedDaysPercentage"
          : null,
        nameSort !== 0
          ? nameSort
          : genderSort !== 0
          ? genderSort
          : emailSort !== 0
          ? emailSort
          : dateSort !== 0
          ? dateSort
          : subscriptionStatusSort !== 0
          ? subscriptionStatusSort
          : subscriptionTypeSort !== 0
          ? subscriptionTypeSort
          : compDaysSort !== 0
          ? compDaysSort
          : completedDaysPercentageSort !== 0
          ? completedDaysPercentageSort
          : null,
        [],
        [],
        true,
        debouncedCompletedDaysPercentageMin,
        debouncedCompletedDaysPercentageMax
      );
      setRegularUsersCount(data?.data?.count);
    } catch (error) {}
  };

  const onGetCSV = async () => {
    try {
      setIsLoadingCSV(true);
      const page = searchParams.get("page");

      const { data } = await getUsersCSV(
        debounceSearch,
        page ? +page - 1 : 0,
        usersLimit,
        filterGender,
        nameSort !== 0
          ? "fullName"
          : genderSort !== 0
          ? "gender"
          : emailSort !== 0
          ? "email"
          : dateSort !== 0
          ? "onboardingAt"
          : subscriptionStatusSort !== 0
          ? "subscriptionStatus"
          : subscriptionTypeSort !== 0
          ? "subscriptionType"
          : compDaysSort !== 0
          ? "numberOfCompletedDays"
          : completedDaysPercentageSort !== 0
          ? "completedDaysPercentage"
          : null,
        nameSort !== 0
          ? nameSort
          : genderSort !== 0
          ? genderSort
          : emailSort !== 0
          ? emailSort
          : dateSort !== 0
          ? dateSort
          : subscriptionStatusSort !== 0
          ? subscriptionStatusSort
          : subscriptionTypeSort !== 0
          ? subscriptionTypeSort
          : compDaysSort !== 0
          ? compDaysSort
          : completedDaysPercentageSort !== 0
          ? completedDaysPercentageSort
          : null,
        filterSubscriptionStatus,
        filterSubscriptionType,
        isProd,
        debouncedCompletedDaysPercentageMin,
        debouncedCompletedDaysPercentageMax
      );
      fileDownload(data, "users.csv");
      if (data?.success) {
      }
    } catch (error) {
    } finally {
      setIsLoadingCSV(false);
    }
  };
  const onGetUsers = async () => {
    try {
      setIsLoading(true);
      const page = searchParams.get("page");

      const { data } = await getUsers(
        debounceSearch,
        page ? +page - 1 : 0,
        usersLimit,
        filterGender,
        nameSort !== 0
          ? "fullName"
          : genderSort !== 0
          ? "gender"
          : emailSort !== 0
          ? "email"
          : dateSort !== 0
          ? "onboardingAt"
          : subscriptionStatusSort !== 0
          ? "subscriptionStatus"
          : subscriptionTypeSort !== 0
          ? "subscriptionType"
          : compDaysSort !== 0
          ? "numberOfCompletedDays"
          : cancellationDateSort !== 0
          ? "cancellationDate"
          : completedDaysPercentageSort !== 0
          ? "completedDaysPercentage"
          : null,
        nameSort !== 0
          ? nameSort
          : genderSort !== 0
          ? genderSort
          : emailSort !== 0
          ? emailSort
          : dateSort !== 0
          ? dateSort
          : subscriptionStatusSort !== 0
          ? subscriptionStatusSort
          : subscriptionTypeSort !== 0
          ? subscriptionTypeSort
          : compDaysSort !== 0
          ? compDaysSort
          : cancellationDateSort !== 0
          ? cancellationDateSort
          : completedDaysPercentageSort !== 0
          ? completedDaysPercentageSort
          : null,
        filterSubscriptionStatus,
        filterSubscriptionType,
        isProd,
        debouncedCompletedDaysPercentageMin,
        debouncedCompletedDaysPercentageMax
      );
      if (data?.success) {
        setUsers(data?.data?.users);
        setPagesCount(Math.ceil(data?.data?.count / usersLimit));
        setCount(data?.data?.count || 0);
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    onGetUsers();
  }, [
    debounceSearch,
    filterGender,
    nameSort,
    genderSort,
    emailSort,
    dateSort,
    subscriptionStatusSort,
    subscriptionTypeSort,
    filterSubscriptionStatus,
    filterSubscriptionType,
    isProd,
    cancellationDateSort,
    compDaysSort,
    completedDaysPercentageSort,
    debouncedCompletedDaysPercentageMin,
    debouncedCompletedDaysPercentageMax,
  ]);

  const selectedFilterOptions =
    filterSubscriptionStatus?.length +
    filterGender?.length +
    filterSubscriptionType?.length +
    (isProd ? 1 : 0) +
    (completedDaysPercentageMin !== null ? 1 : 0) +
    (completedDaysPercentageMax !== null ? 1 : 0);

  useEffect(() => {
    getCountOfRegularUsers();
  }, []);
  return (
    <div className={styles.wrapper}>
      {userIdFromUrl && (
        <UserProfileCoachView
          isVisible={!!userIdFromUrl}
          onClose={handleCloseModal}
          userId={userIdFromUrl}
          refetchUsers={onGetUsers}
        />
      )}
      <header className={styles.header}>
        <h4 className={styles.title}>
          Users
          <span className={styles.countUsers}>({regularUsersCount})</span>
        </h4>
        <div className={styles.headerAddButton}></div>
      </header>

      <section className={styles.contentContainer}>
        <div className={styles.contentContainerHeader}>
          <div className={styles.searchContainer}>
            <SearchInput
              placeholder="Search"
              value={search}
              onChange={onChangeSearch}
            />
          </div>

          <Button
            onClick={onGetCSV}
            loading={isLoadingCSV}
            leftIcon={<DownloadIcon />}
            title="Export .CSV"
            size="x-small"
            styleType="disabled"
            style={{
              marginLeft: "auto",
              marginRight: "32px",
              width: 148,
              borderRadius: 16,
              backgroundColor: "#E3E6EC",
              paddingLeft: 12,
              paddingRight: 16,
            }}
          />
          <div ref={filterRef}>
            <div
              onClick={() => setIsOpenFilter((prev) => !prev)}
              className={clsx(styles.filterButton, {
                [styles.activeFilterButton]: isOpenFilter,
              })}
            >
              {selectedFilterOptions ? (
                <div className={styles.filterButtonCounter}>
                  {selectedFilterOptions}
                </div>
              ) : (
                <></>
              )}
              <FilterIcon />
            </div>
            {isOpenFilter && (
              <UserFilter
                setIsOpen={setIsOpenFilter}
                setFilterSubscriptionStatus={(value) => {
                  onChangePage(1);

                  setFilterSubscriptionStatus(value);
                }}
                filterSubscriptionStatus={filterSubscriptionStatus}
                setFilterSubscriptionType={(value) => {
                  onChangePage(1);

                  setFilterSubscriptionType(value);
                }}
                filterSubscriptionType={filterSubscriptionType}
                filterGender={filterGender}
                setFilterGender={(genders) => {
                  onChangePage(1);
                  setFilterGender(genders);
                }}
                isProd={isProd}
                setIsProd={setIsProd}
                completedDaysPercentageMin={completedDaysPercentageMin}
                setCompletedDaysPercentageMin={(value) => {
                  onChangePage(1);
                  setCompletedDaysPercentageMin(value);
                }}
                completedDaysPercentageMax={completedDaysPercentageMax}
                setCompletedDaysPercentageMax={(value) => {
                  onChangePage(1);
                  setCompletedDaysPercentageMax(value);
                }}
              />
            )}
          </div>
        </div>
        {filterGender?.length ||
        filterSubscriptionStatus?.length ||
        filterSubscriptionType?.length ||
        isProd ||
        completedDaysPercentageMin !== null ||
        completedDaysPercentageMax !== null ? (
          <>
            <div className={styles.selectedFiltersTags}>
              {filterGender?.map((item) => {
                return (
                  <Tag
                    key={item}
                    title={item}
                    onPress={() => {
                      setFilterGender(filterGender.filter((el) => el !== item));
                    }}
                  />
                );
              })}
              {isProd && (
                <Tag
                  title="Regular Users"
                  onPress={() => {
                    setIsProd(false);
                  }}
                />
              )}
              {filterSubscriptionType?.map((item) => {
                return (
                  <Tag
                    key={item}
                    title={
                      SubscriptionPlans?.find((el) => el.value === item)
                        ?.label ?? ""
                    }
                    onPress={() => {
                      setFilterSubscriptionType(
                        filterSubscriptionType.filter((el) => el !== item)
                      );
                    }}
                  />
                );
              })}
              {filterSubscriptionStatus?.map((item) => {
                return (
                  <Tag
                    key={item}
                    title={
                      SubscriptionStatuses?.find((el) => el.value === item)
                        ?.label ?? ""
                    }
                    onPress={() => {
                      setFilterSubscriptionStatus(
                        filterSubscriptionStatus.filter((el) => el !== item)
                      );
                    }}
                  />
                );
              })}
              {completedDaysPercentageMin !== null && (
                <Tag
                  title={`Min %: ${completedDaysPercentageMin}`}
                  onPress={() => {
                    setCompletedDaysPercentageMin(null);
                  }}
                />
              )}
              {completedDaysPercentageMax !== null && (
                <Tag
                  title={`Max %: ${completedDaysPercentageMax}`}
                  onPress={() => {
                    setCompletedDaysPercentageMax(null);
                  }}
                />
              )}
            </div>
            <div className={styles.filterResults}>
              Showing {count} of {regularUsersCount} results.{" "}
              <span
                onClick={() => {
                  setFilterGender([]);
                  setFilterSubscriptionStatus([]);
                  setFilterSubscriptionType([]);
                  setIsProd(false);
                  setCompletedDaysPercentageMin(null);
                  setCompletedDaysPercentageMax(null);
                }}
              >
                Clear filters
              </span>
            </div>
          </>
        ) : null}

        <div className={styles.sectionHeader}>
          <div
            onClick={() => {
              setDateSort(0);
              setGenderSort(0);
              setEmailSort(0);
              setSubscriptionTypeSort(0);
              setCompDaysSort(0);
              setCancellationDateSort(0);
              setCompletedDaysPercentageSort(0);
              setNameSort(nameSort === 0 ? -1 : nameSort === -1 ? 1 : 0);
            }}
            className={clsx(styles.nameBlock, {
              [styles.activeSortValue]: nameSort !== 0,
            })}
          >
            <p>User</p>{" "}
            <ArrowSmallDownIcon
              className={clsx(styles.sectionHeaderArrow, {
                [styles.sectionHeaderArrowUp]: nameSort === -1,
              })}
            />
          </div>
          <div
            onClick={() => {
              setDateSort(0);
              setNameSort(0);
              setEmailSort(0);
              setCompDaysSort(0);
              setCancellationDateSort(0);
              setCompletedDaysPercentageSort(0);

              setSubscriptionStatusSort(0);
              setSubscriptionTypeSort(0);
              setGenderSort(genderSort === 0 ? -1 : genderSort === -1 ? 1 : 0);
            }}
            style={{ flex: 0.2 }}
            className={clsx(styles.genderBlock, {
              [styles.activeSortValue]: genderSort !== 0,
            })}
          >
            <p>Gender</p>{" "}
            <ArrowSmallDownIcon
              className={clsx(styles.sectionHeaderArrow, {
                [styles.sectionHeaderArrowUp]: genderSort === -1,
              })}
            />
          </div>
          <div
            onClick={() => {
              setDateSort(0);
              setCancellationDateSort(0);
              setNameSort(0);
              setEmailSort(0);
              setGenderSort(0);
              setSubscriptionStatusSort(0);
              setSubscriptionTypeSort(0);
              setCompletedDaysPercentageSort(0);
              setCompDaysSort(
                compDaysSort === 0 ? -1 : compDaysSort === -1 ? 1 : 0
              );
            }}
            className={clsx(styles.compDaysBlock, {
              [styles.activeSortValue]: compDaysSort !== 0,
            })}
          >
            <p>Comp. days</p>{" "}
            <ArrowSmallDownIcon
              className={clsx(styles.sectionHeaderArrow, {
                [styles.sectionHeaderArrowUp]: compDaysSort === -1,
              })}
            />
          </div>

          <div
            onClick={() => {
              setDateSort(0);
              setCancellationDateSort(0);
              setNameSort(0);
              setEmailSort(0);
              setGenderSort(0);
              setSubscriptionStatusSort(0);
              setSubscriptionTypeSort(0);
              setCompDaysSort(0);
              setCompletedDaysPercentageSort(
                completedDaysPercentageSort === 0
                  ? -1
                  : completedDaysPercentageSort === -1
                  ? 1
                  : 0
              );
            }}
            className={clsx(styles.compDaysBlock, {
              [styles.activeSortValue]: completedDaysPercentageSort !== 0,
            })}
          >
            <p>Comp. days %</p>{" "}
            <ArrowSmallDownIcon
              className={clsx(styles.sectionHeaderArrow, {
                [styles.sectionHeaderArrowUp]: completedDaysPercentageSort === -1,
              })}
            />
          </div>

          <div
            onClick={() => {
              setDateSort(0);
              setGenderSort(0);
              setNameSort(0);
              setCompDaysSort(0);
              setEmailSort(0);
              setSubscriptionStatusSort(0);
              setCancellationDateSort(0);
              setCompletedDaysPercentageSort(0);

              setSubscriptionTypeSort(
                subscriptionTypeSort === 0
                  ? -1
                  : subscriptionTypeSort === -1
                  ? 1
                  : 0
              );
            }}
            style={{ flex: 0.25 }}
            className={clsx(styles.genderBlock, {
              [styles.activeSortValue]: subscriptionTypeSort !== 0,
            })}
          >
            <p>Subscription Plan</p>{" "}
            <ArrowSmallDownIcon
              className={clsx(styles.sectionHeaderArrow, {
                [styles.sectionHeaderArrowUp]: subscriptionTypeSort === -1,
              })}
            />
          </div>
          <div
            onClick={() => {
              setDateSort(0);
              setGenderSort(0);
              setCompDaysSort(0);
              setNameSort(0);
              setEmailSort(0);
              setSubscriptionTypeSort(0);
              setCancellationDateSort(0);
              setCompletedDaysPercentageSort(0);

              setSubscriptionStatusSort(
                subscriptionStatusSort === 0
                  ? -1
                  : subscriptionStatusSort === -1
                  ? 1
                  : 0
              );
            }}
            style={{ flex: 0.25 }}
            className={clsx(styles.genderBlock, {
              [styles.activeSortValue]: subscriptionStatusSort !== 0,
            })}
          >
            <p>Subscription Status</p>{" "}
            <ArrowSmallDownIcon
              className={clsx(styles.sectionHeaderArrow, {
                [styles.sectionHeaderArrowUp]: subscriptionStatusSort === -1,
              })}
            />
          </div>

          <div
            onClick={() => {
              setEmailSort(0);
              setCompDaysSort(0);
              setGenderSort(0);
              setNameSort(0);
              setSubscriptionTypeSort(0);
              setCancellationDateSort(0);
              setCompletedDaysPercentageSort(0);

              setDateSort(dateSort === 0 ? -1 : dateSort === -1 ? 1 : 0);
            }}
            className={clsx(styles.dateBlock, {
              [styles.activeSortValue]: dateSort !== 0,
            })}
          >
            <p>Reg. date</p>{" "}
            <ArrowSmallDownIcon
              className={clsx(styles.sectionHeaderArrow, {
                [styles.sectionHeaderArrowUp]: dateSort === -1,
              })}
            />
          </div>
          <div
            onClick={() => {
              setEmailSort(0);
              setCompDaysSort(0);
              setGenderSort(0);
              setNameSort(0);
              setSubscriptionTypeSort(0);
              setDateSort(0);
              setCompletedDaysPercentageSort(0);
              setCancellationDateSort(
                cancellationDateSort === 0
                  ? -1
                  : cancellationDateSort === -1
                  ? 1
                  : 0
              );
            }}
            className={clsx(styles.dateBlock, {
              [styles.activeSortValue]: cancellationDateSort !== 0,
            })}
          >
            <p>Cancel. date</p>{" "}
            <ArrowSmallDownIcon
              className={clsx(styles.sectionHeaderArrow, {
                [styles.sectionHeaderArrowUp]: cancellationDateSort === -1,
              })}
            />
          </div>
        </div>

        <div className={styles.listContainer}>
          {isLoading ? (
            <div className={styles.loaderWrapper}>
              <PulseLoader color={"#7D4AFB"} />
            </div>
          ) : (
            users.map((item, index) => (
              <UserItemCoachView
                key={index}
                item={item}
                refetchUsers={() => onGetUsers()}
              />
            ))
          )}
        </div>
        <PaginationButtons
          pagesCount={pagesCount}
          page={page ? +page : 1}
          onPress={(index) => {
            onChangePage(index);
            onGetUsers();
          }}
        />
      </section>
    </div>
  );
};

export default UsersCoach;
